import { TLanguage } from "../../../types/language-types";
import styles from "./flag.module.less";

export type TFlagProps = {
  country: TLanguage;
};

export const Flag = ({ country }: TFlagProps) => {
  return <div className={[styles.flag, styles[country]].join(" ")} />;
};

export default Flag;
